module.exports = "/_next/static/images/a96ad5e41de2f2cebea3cffd1cbbed95-nu-card-lg@3x.jpg";